import HeroSection from 'features/website/components/HeroSection';
import WhoWeAreSection from 'features/website/components/WhoWeAreSection';
import HowItWorksSection from 'features/website/components/HowItWorksSection';
import AmenitiesSection from 'features/website/components/AmenitiesSection';
import TestimonialsSection from 'features/website/components/TestimonialsSection';
import ReadyToStartSection from 'features/website/components/ReadyToStartSection';
import Footer from 'shared/components/footer/Footer';
import FAQSection from 'features/website/components/FAQSection';
import Container from 'shared/components/container/Container';
import useScrollToSection from 'shared/hooks/use-scroll-to-section';

const Website = () => {

    useScrollToSection();
    
    return (
        <div className="min-h-screen relative overflow-hidden bg-white">
            <HeroSection />
            {
                /*  Not adding the container at the root because we need
                    full-width for the HeroSection above.
                 */
            }
            <Container className="max-w-7xl">
                <WhoWeAreSection />
                <HowItWorksSection />
                <AmenitiesSection />
                <TestimonialsSection />
                <FAQSection />
                <ReadyToStartSection />
                <Footer />
            </Container>
        </div>
    );
};

export default Website;
